<template>
    <div>
      <el-carousel height="2.9rem" :autoplay="true" :interval="5000">
        <el-carousel-item>
          <img src="../../assets/images/banner/product/donghua/1.jpg" width="100%" height="100%">
        </el-carousel-item>
        <el-carousel-item>
          <img src="../../assets/images/banner/product/donghua/2.jpg" width="100%" height="100%">
        </el-carousel-item>
        <el-carousel-item>
          <img src="../../assets/images/banner/product/donghua/3.jpg" width="100%" height="100%">
        </el-carousel-item>
      </el-carousel>
        <div class="box2">
            <div class="lef">
                <div>工程动画产品</div>
                <!--<el-menu
                        default-active="2"
                        class="el-menu-vertical-demo"
                        @open="handleOpen"
                        @close="handleClose">
                    <el-submenu index="1">
                        <template slot="title">
                            <i class="el-icon-location"></i>
                            <span>导航一</span>
                        </template>
                        <el-menu-item-group>
                            <template slot="title">分组一</template>
                            <el-menu-item index="1-1">选项1</el-menu-item>
                            <el-menu-item index="1-2">选项2</el-menu-item>
                        </el-menu-item-group>
                        <el-menu-item-group title="分组2">
                            <el-menu-item index="1-3">选项3</el-menu-item>
                        </el-menu-item-group>
                        <el-submenu index="1-4">
                            <template slot="title">选项4</template>
                            <el-menu-item index="1-4-1">选项1</el-menu-item>
                        </el-submenu>
                    </el-submenu>
                    <el-menu-item index="2">
                        <i class="el-icon-menu"></i>
                        <span slot="title">导航二</span>
                    </el-menu-item>
                    <el-menu-item index="3" disabled>
                        <i class="el-icon-document"></i>
                        <span slot="title">导航三</span>
                    </el-menu-item>
                    <el-menu-item index="4">
                        <i class="el-icon-setting"></i>
                        <span slot="title">导航四</span>
                    </el-menu-item>
                </el-menu>-->
                <p v-for="item in menuList" :key="item.id">
                    <a :class="item.id==code? 'don':''" @click="menuClick(item.id)">· {{item.title}}</a>
                </p>
            </div>
            <div v-if="dataList" class="rit">
                <p class="tit">{{dataList.title}}</p>
                <div v-if="dataList.url" class="vid">
                    <iframe :src="dataList.url" width="100%" height="100%" frameborder="0" allowFullScreen></iframe>
                </div>
                <div v-if="dataList.img" class="img">
                    <img :src="dataList.img">
                </div>
                <div class="but">
                    <span class="l" @click="upClick(dataList.id)">上一篇</span>
                    <span class="r" @click="nextClick(dataList.id)">下一篇</span>
                </div>
            </div>
            <div v-else class="prop">暂时没有内容~</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NewsCeter",
        data(){
            return{
                code:sessionStorage.getItem('carCode'),
                dataList:{},
                menuList:[
                    {id:1,title:'深圳《平安国际金融中心》',url:'https://player.youku.com/embed/XMTM4OTExNDQzNg=='},
                    {id:2,title:'天津《周大福中心》',url:'https://player.youku.com/embed/XMTM4OTExNjcwMA=='},
                    {id:3,title:'深圳《腾讯滨海总部大厦》',url:'https://player.youku.com/embed/XMTM4OTExNDk0NA=='},
                    {id:4,title:'厦门《国际中心》',url:'https://player.youku.com/embed/XMTM4OTExMTg4OA=='},
                    {id:5,title:'《港珠澳大桥》投标动画',img:require('../../assets/images/progd/cartoon/b1.jpg')},
                    {id:6,title:'深圳地铁盾构施工动画演示',url:'https://player.youku.com/embed/XMTM4OTEyMjEyNA=='},
                    {id:7,title:'深圳地铁7、9号线施工动画演示',url:'https://player.youku.com/embed/XMTM4OTEyMTEwMA=='},
                    {id:8,title:'隧道工程施工动画',img:require('../../assets/images/progd/cartoon/b4.jpg')},
                    {id:9,title:'港口码头施工动画演示',url:'https://player.youku.com/embed/XMTM4OTQ3NTgzMg=='},
                    {id:10,title:'湘江综合水利枢纽工程',url:'https://player.youku.com/embed/XMTM4OTQ4MzgxNg=='},
                    {id:11,title:'徐大堡核电厂施工动画演示',url:'https://player.youku.com/embed/XMTM4OTQ5MjQxNg=='},
                    {id:12,title:'南宁邕宁水利枢纽工程动画演示',url:'https://player.youku.com/embed/XMTM4OTUwMTcyNA=='},
                    {id:13,title:'Z形幅超深地连墙施工工法',url:'https://player.youku.com/embed/XMTM4OTA0NDIxMg=='},
                    {id:14,title:'国家级工法灌注工法',url:'https://player.youku.com/embed/XMTM4OTA5MTc0MA=='},
                    {id:15,title:'伸缩缝施工国家级工法',url:'https://player.youku.com/embed/XMTM4OTEwMzc0MA=='},
                    {id:16,title:'现浇连续箱梁满堂支架工法',url:'https://player.youku.com/embed/XMTM4OTA5NTU0NA=='},
                    {id:17,title:'顶级的飞手',img:require('../../assets/images/progd/cartoon/e1.jpg')},
                    {id:18,title:'高端的设备',img:require('../../assets/images/progd/cartoon/e2.jpg')},
                    {id:19,title:'一流的制作团队',img:require('../../assets/images/progd/cartoon/e3.jpg')},
                    {id:20,title:'丰富的经验',img:require('../../assets/images/progd/cartoon/e4.jpg')},
                    {id:21,title:'安全生产警示片-物体打击案例',url:'https://player.youku.com/embed/XMTM4OTEyMjcxMg=='},
                    {id:22,title:'安全生产警示片-高处坠落案例',url:'https://player.youku.com/embed/XMTM4OTEyODQ2NA=='},
                    {id:23,title:'基坑坍塌施工事故动画模拟',img:require('../../assets/images/progd/cartoon/f3.jpg')},
                    {id:24,title:'建筑施工安全生产警示片',img:require('../../assets/images/progd/cartoon/f4.jpg')},
                    {id:25,title:'270度全息幻影成像',img:require('../../assets/images/progd/cartoon/g1.jpg')},
                    {id:26,title:'无人机航拍',url:'https://player.youku.com/embed/XMTM4OTEyODQ2NA=='},
                    {id:27,title:'施工质量、安全等培训软件开发',img:require('../../assets/images/progd/cartoon/g3.jpg')},
                    {id:28,title:'现场触摸屏系统展示',img:require('../../assets/images/progd/cartoon/g4.jpg')},
                    {id:29,title:'《央视大楼》幕墙动画',url:'https://player.youku.com/embed/XMjM5MTA2MTQ4'},
                    {id:30,title:'深圳证券大厦幕墙施工动画',url:'https://player.youku.com/embed/XMjM5MTA1MTY4'},
                    {id:31,title:'《百度大厦》幕墙动画',url:'https://player.youku.com/embed/XMjM5MTA2MTQ4'},
                    {id:32,title:'华润总部大厦',img:require('../../assets/images/progd/cartoon/h4.jpg')}
                ]
            }
        },
        methods:{
            menuClick(id){
                if(this.code!==id){
                    this.code=id;
                    this.dataList=this.menuList[this.code-1];
                    sessionStorage.setItem('carCode',id);
                }
            },
            upClick(id){
                if(id!==1){
                    this.code=id-1;
                    this.dataList=this.menuList[this.code-1];
                    sessionStorage.setItem('carCode',id-1);
                }
            },
            nextClick(id){
                let count=this.menuList.length;
                if(id!==count){
                    this.code=id+1;
                    this.dataList=this.menuList[this.code-1];
                    sessionStorage.setItem('carCode',id+1);
                }
            }
        },
        mounted(){
            this.dataList=this.menuList[this.code-1];
            document.documentElement.scrollTop=0;
        }
    }
</script>

<style lang="scss" scoped>
    .box{
        height: 2.9rem;
        width: 100%;
        background: url("../../assets/images/zh.jpg");
        background-size: 100% 100%;
    }
    .box2{
        width: 12rem;
        margin:.6rem auto 0;
        display: flex;
        .lef{
            width: 1.76rem;
            overflow: hidden;
            div{
                font-size: .2rem;
                position: relative;
                padding-left: .1rem;
                margin-bottom:.19rem;
            }
            div::before{
                position: absolute;
                content: "";
                left:0rem;
                top:.06rem;
                background: #E70F20;
                width: 2px;
                height: .16rem;
            }
            p{
                line-height: .34rem;
                font-size: .16rem;
                width: 1.76rem;
                color:#3F3F3F;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                cursor:pointer;
                a{
                    display: inline-block;
                    width: 100%;
                }
            }
            .don{
                color:#E70F20
            }
        }
        .rit{
            margin-left: .15rem;
            border-left: 1px solid #E5E5E5;
            padding-left:.85rem;
            width: 10.07rem;
            p.tit{
                width: 5.7rem;
                font-size: .26rem;
                text-align: center;
                margin: 0 auto;
                line-height: .41rem;
                letter-spacing: 1px;
            }
            div.vid{
                margin:.58rem auto 0;
                width: 7rem;
                height: 3.94rem;
            }
            div.img{
                text-align: center;
                margin-top:.58rem;
                img{
                    width: 7rem;
                    height: 3.94rem;
                }
            }
            div.but{
                text-align: center;
                margin-top:.56rem;
                span{
                    width: 69px;
                    height: 26px;
                    line-height: 29px;
                    display: inline-block;
                    font-size: 12px;
                    margin:0 .25rem;
                    cursor: pointer;
                }
                .l{
                    background: url("../../assets/images/pg.png");
                    background-size: 100% 100%;
                    padding-left:.07rem
                }
                .r{
                    background: url("../../assets/images/pg2.png");
                    background-size: 100% 100%;
                    padding-right:.07rem
                }
            }
        }
        .prop{
            width: 10rem;
            font-size: .26rem;
            color:#ddd;
            text-align: center;
            padding-top:1rem;
        }
    }
</style>
